import { Link } from 'react-router-dom';

/**
 * Category list used by both desktop Navbar and MobileMenu.
 * Falls back to hardcoded list if API fails so navigation never breaks.
 */
export const FALLBACK_CATEGORIES = [
  { id: 'mugg', href: '/produkter/mugg', name: 'Muggar' },
  { id: 'tshirt', href: '/produkter/tshirt', name: 'T-shirts' },
  { id: 'hoodie', href: '/produkter/hoodie', name: 'Hoodies' },
  { id: 'poster', href: '/produkter/poster', name: 'Posters' },
  { id: 'mobilskal', href: '/produkter/mobilskal', name: 'Mobilskal' },
  { id: 'tygkasse', href: '/produkter/tygkasse', name: 'Tygkassar' },
  { id: 'namnskylt', href: '/produkter/namnskylt', name: 'Namnlappar' },
  { id: 'kalender', href: '/produkter/kalender', name: 'Kalendrar' },
  { id: 'fotoalbum', href: '/produkter/fotoalbum', name: 'Fotoalbum' },
];

export const MobileMenu = ({ isOpen, categories: cats, user, onClose, onLogout }) => {
  if (!isOpen) return null;
  const list = (cats && cats.length ? cats : FALLBACK_CATEGORIES).filter((c) => !c.hidden_in_header);
  return (
    <div className="md:hidden fixed inset-x-0 top-20 bg-white border-b border-slate-200 shadow-lg animate-fade-in z-50" data-testid="mobile-menu">
      <div className="container-main py-4 space-y-1 max-h-[calc(100vh-80px)] overflow-y-auto">
        <Link to="/" className="block text-base font-medium text-slate-700 hover:text-primary py-2.5 px-2" onClick={onClose}>Hem</Link>
        <Link to="/produkter" className="block text-base font-semibold text-[#2a9d8f] py-2.5 px-2" onClick={onClose}>Alla produkter</Link>
        <div className="pl-2 space-y-0.5">
          {list.map((cat) => (
            <Link key={cat.id || cat.href} to={cat.href || `/produkter/${cat.id}`} className="flex items-center gap-3 py-2.5 px-2 rounded-lg hover:bg-slate-50 transition-colors" onClick={onClose}>
              <span className="text-sm font-medium text-slate-600">{cat.name || cat.label}</span>
            </Link>
          ))}
        </div>
        <Link to="/foretag" className="block text-base font-medium text-slate-700 hover:text-primary py-2.5 px-2" onClick={onClose}>Företag</Link>
        <div className="border-t border-slate-100 pt-3 mt-3 space-y-1">
          {user ? (
            <>
              <Link to="/konto" className="block text-base font-medium text-slate-700 hover:text-primary py-2.5 px-2" onClick={onClose}>Mitt konto</Link>
              <button onClick={onLogout} className="block text-base font-medium text-slate-500 hover:text-primary py-2.5 px-2">Logga ut</button>
            </>
          ) : (
            <>
              <Link to="/logga-in" className="block text-base font-medium text-slate-700 hover:text-primary py-2.5 px-2" onClick={onClose}>Logga in</Link>
              <Link to="/registrera" className="block text-base font-medium text-[#2a9d8f] py-2.5 px-2" onClick={onClose}>Registrera</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// Kept for backwards-compat with Navbar imports
export const categories = FALLBACK_CATEGORIES.map((c) => ({ href: c.href, label: c.name }));
